import { render, staticRenderFns } from "./THGCarForm.vue?vue&type=template&id=3d29f740&scoped=true"
import script from "./THGCarForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./THGCarForm.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./THGCarForm.vue?vue&type=style&index=0&id=3d29f740&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d29f740",
  null
  
)

export default component.exports